import { useSearchParams } from "react-router-dom";

export const useUserId = (): string => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("extid");
  return id || "";
}